<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="400px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja narzutu: <strong>{{ nettoMarkUp.name }}</strong>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="nettoMarkUp.value"
                            label="Wartość"
                            type="number"
                            suffix="%"
                            min="1"
                            :error-messages="valueErrors"
                            outlined
                            dense
                            required
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'NettoMarkUpDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        nettoMarkUpData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            nettoMarkUp: {
                name: null,
                value: null
            },
            actionLoading: false,
        }
    },
    validations: {
        nettoMarkUp: {
            value: {
                required,
                integer
            }
        }
    },
    computed: {
        // Walidacje
        valueErrors() {
            const errors = []

            if (!this.$v.nettoMarkUp.value.$dirty) return errors
            !this.$v.nettoMarkUp.value.required && errors.push('Proszę podać wartość procentową narzutu.')
            !this.$v.nettoMarkUp.value.integer && errors.push('Proszę podać liczbę całkowitą.')

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.nettoMarkUp = JSON.parse(JSON.stringify(this.nettoMarkUpData))
            }
        },
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true

            this.$store.dispatch('configurations/calculationsCosts/updateNettoMarkUp', this.nettoMarkUp)
                .then(() => {
                    this.$emit('on-confirm')
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            setTimeout(() => {
                this.nettoMarkUp = {
                    name: null,
                    value: null
                }
                this.$v.$reset()
            }, 500)

            this.$emit('on-close')
        }
    }
}
</script>

